<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i"></a>Something About Midnight</h1>
<p class="author">Dolores Hitchens writing as D.B. Olsen</p>
<div class="img_container1">
<img alt="Images" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?61ddec32